import React from "react";
import * as Icons from "lucide-react";

const DynamicIcon = ({ name, size, color }) => {
  const IconComponent = Icons[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in lucide-react.`);
    return <></>;
  }

  return <IconComponent size={size} color={color} />;
};

export default DynamicIcon;